
const actionFactories = {
    init: (host) => ({ host }),
    windowMessageReceived: (message) => ({ message }),
    autoSignInCanceled: () => ({}),
    passiveLoginChanged: (value) => ({value}),
    settingsLoaded: (settings) => ({settings}),
    settingsChanged: (changes) => ({changes}),
    clientSettingsChanged: (changes) => ({changes}),
    userChanged: () => ({}),
    logout: () => ({}),
    timeChanged: (time) => ({time}),
    postsLoaded: (posts) => ({posts}),
    feedLoading: (key) => ({key}),
    feedLoaded: (key, posts, more) => ({key, posts, more}),
    feedTailLoaded: (key, lastPostId, posts, more) => ({key, posts, more, lastPostId}),
    feedLoadFailed: (key) => ({key}),
    feedLoadDone: (key) => ({key}),
    feedLoadBailedOut: (key) => ({key}),
    feedLoadReset: (key) => ({key}),
    feedLoadResetAll: () => ({}),
    feedsCleared: (sort) => ({sort}),
    contentListLoaded: (key, content, more) => ({key, content, more}),
    contentListExtended: (key, content, more) => ({key, content, more}),
    communityListLoaded: (sort, communities, timestamp) => ({sort, communities, timestamp}),
    communitiesLoaded: (communities, timestamp) => ({communities, timestamp}),
    communityChanged: (community) => ({community}),
    postVoteChanged: (id, voteState) => ({id, voteState}),
    postHiddenChanged: (id, hidden) => ({id, hidden}),
    postDeleted: (id) => ({id}),
    postEdited: (id, content) => ({id, content}),
    postFlairChanged: (id, flairText, flairClass) => ({id, flairText, flairClass}),
    postNsfw: (id, newState) => ({id, newState}),
    postModDistinguished: (id, newState) => ({id, newState}),
    postSticky: (id, newState) => ({id, newState}),
    postLock: (id, newState) => ({id, newState}),
    postRemove: (id, moderator) => ({id, moderator}),
    postApprove: (id, moderator) => ({id, moderator}),
    postIgnoreReports: (id, ignoreReports) => ({id, ignoreReports}),
    postRetryablePreview: (id) => ({id}),

    commentsLoaded: (comments) => ({comments}),
    commentListLoading: (key) => ({key}),
    commentListLoaded: (key, ids, comments, more) => ({key, ids, comments, more}),
    commentListExtended: (key, ids, comments, page, more) => ({key, ids, comments, page, more}),
    commentListLoadFailed: (key) => ({key}),
    commentCreated: (comment) => ({comment}),
    commentEdited: (id, content) => ({id, content}),
    commentVoteChanged: (id, voteState) => ({id, voteState}),
    commentDeleted: (id) => ({id}),
    commentModDistinguished: (id, newState) => ({id, newState}),
    commentSticky: (id, newState) => ({id, newState}),
    commentRemove: (id, moderator) => ({id, moderator}),
    commentApprove: (id, moderator) => ({id, moderator}),
    commentIgnoreReports: (id, ignoreReports) => ({id, ignoreReports}),

    savedFeedsLoaded: (feeds) => ({feeds}),
    savedFeedsRemoved: (id) => ({id}),
    savedFeedsAdded: (feed) => ({feed}),
    savedFeedsUpdated: (feed) => ({feed}),

    adConsumerAdded: () => ({}),
    adConsumerRemoved: () => ({}),
    adConfigChanged: (config) => ({config}),
    adUnitsChanged: (units) => ({units}),

    lastFeedPosChanged: (key, id) => ({key, id}),

    feedAdUnitsChanged: (key, index, data) => ({key, index, data}),
    feedAdUnitsCleared: (key) => ({key}),

    googleAdsEnabledChanged: (value) => ({value}),
};

export default actionFactories;
